import {PIXI} from '@colonist/pixi'
import {UIGameConstants} from './UIGameConstants'
import {SpriteView} from '../ui_canvas_engine/SpriteView'
import {CardView} from '../ui_canvas_engine/CardView'
import {Sprites} from './UIGameImageDictionary'
import {UIGameSpriteHandler} from '../UIGameSpriteHandler'
import {UIGameAnimationBase} from '../ui_canvas_engine/animation/UIGameAnimationBase'
import {UIGameFlickerAnimation} from '../ui_canvas_engine/animation/UIGameFlickerAnimation'
import {CardEnum} from '@colonist/game-states'
import {ArrayUtils} from '@colonist/utils'

interface HoverResourceView {
    cardView: SpriteView
    missingCardOverlay: PIXI.Container | undefined
}

export class UIGameHoverResourceInfoView extends PIXI.Container {
    private missingCardOverlays: PIXI.Container
    private resourceCardFlickerAnimation: UIGameAnimationBase
    private readonly cardEnums: CardEnum[]
    private readonly hoverResourceViews: HoverResourceView[]

    constructor(cardEnums: CardEnum[], viewToPlaceAbove: PIXI.Container, container: PIXI.Container, cardInventory: CardEnum[], isPlacedOnCanvasStage: boolean = true) {
        super()

        this.cardEnums = cardEnums
        this.hoverResourceViews = []

        this.createCardViews(cardEnums, cardInventory, isPlacedOnCanvasStage)

        const point = isPlacedOnCanvasStage ? viewToPlaceAbove.getGlobalPosition() : new PIXI.Point(0, 0)

        this.x = point.x - this.width / 2 + viewToPlaceAbove.width / 2
        this.y = point.y - this.height * 0.92

        container.addChild(this)
    }

    private createCardViews(cardEnums: CardEnum[], cardInventory: CardEnum[], isPlacedOnCanvasStage: boolean) {
        const width = isPlacedOnCanvasStage ? 30 : 26
        const height = width * UIGameConstants.CARD_RATIO
        this.missingCardOverlays = new PIXI.Container()

        let x = 0
        for(const [index, cardEnum] of cardEnums.entries()) {
            const hasCardInInventory = cardInventory.includes(cardEnum)
            ArrayUtils.removeElementFromArray(cardInventory, cardEnum)

            const texture = CardView.getTextureForCard(cardEnum)
            const cardView = new SpriteView(x, 0, width, height, this, texture)

            x += width * 0.97

            this.hoverResourceViews[index] = {
                cardView: cardView,
                missingCardOverlay: !hasCardInInventory ? this.setCardViewOverlays(cardView) : undefined,
            }
        }

        this.addChild(this.missingCardOverlays)
    }

    private setCardViewOverlays(cardView: SpriteView): PIXI.Container {
        const missingCardOverlay = new PIXI.Container()

        const greyOverlay = new SpriteView(cardView.x, cardView.y, cardView.width, cardView.height, missingCardOverlay, UIGameSpriteHandler.getTextureFromSpritesheet(Sprites.card_overlay_black))
        const whiteOverlay = new SpriteView(cardView.x, cardView.y, cardView.width, cardView.height, missingCardOverlay, UIGameSpriteHandler.getTextureFromSpritesheet(Sprites.card_overlay_white))

        greyOverlay.alpha = 0.65
        whiteOverlay.alpha = 0.2

        return this.missingCardOverlays.addChild(missingCardOverlay)
    }

    flickerMissingCards() {
        if(this.resourceCardFlickerAnimation != undefined) this.resourceCardFlickerAnimation.stop()

        const flickerDuration = 500
        const flickerOptions = {
            speed: 3,
            minOpacity: 0,
            maxOpacity: 1,
        }
        this.resourceCardFlickerAnimation = new UIGameFlickerAnimation(this.missingCardOverlays, flickerDuration, flickerOptions).start()
    }

    removeHover() {
        if(this.parent == undefined) return
        this.parent.removeChild(this)
    }

    updateCardViews(cardInventory: CardEnum[]) {
        for(const [index, cardEnum] of this.cardEnums.entries()) {
            const hasCardInInventory = cardInventory.includes(cardEnum)
            ArrayUtils.removeElementFromArray(cardInventory, cardEnum)

            const hoverResourceView = this.hoverResourceViews[index]

            if(hasCardInInventory && hoverResourceView.missingCardOverlay != undefined) {
                this.missingCardOverlays.removeChild(hoverResourceView.missingCardOverlay)
                return
            }

            if(!hasCardInInventory && hoverResourceView.missingCardOverlay == undefined) hoverResourceView.missingCardOverlay = this.setCardViewOverlays(hoverResourceView.cardView)
        }
    }
}
